import history from 'history/browser';
import React, { useContext, useEffect } from 'react';
import { Router } from 'react-router-dom';

import { getRoles, getToken } from '../util/keycloak.js';
import MenuAppBar from './menuapp/MenuAppBar';
import PageContent from './PageContent';
import ErrorBoundary from './share/ErrorBoundary';
import AplicacaoContext from '../contexts/AplicacaoContext';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(
  () => {
    return ({
      root: {
        display: 'flex',
      },
    });
  });

  function App (props) {
  const aplicacaoContext = useContext(AplicacaoContext);

  useEffect(() => {
    function carregarIniciais () {
      aplicacaoContext.getBeneficiarios();
      aplicacaoContext.getBeneficiariosMaisPensionistas();
      aplicacaoContext.getTiposDeAtendimento();
      aplicacaoContext.getTiposDeSituacao();
      aplicacaoContext.getMotivosDeGlosa();
      aplicacaoContext.getPrestadores();
      aplicacaoContext.getPrestadoresCredenciados();
      aplicacaoContext.getFaturas();
      aplicacaoContext.getLotes();
      aplicacaoContext.getPrestadorSemOrgaoExterno();
      aplicacaoContext.getOrgaosExternos();
      aplicacaoContext.getBancos();
      aplicacaoContext.getDemonstrativos();
      aplicacaoContext.getUfs();
      aplicacaoContext.getProfissionais();
      aplicacaoContext.getEspecialidades();
      aplicacaoContext.getCROs();
      aplicacaoContext.getGrupos();
      aplicacaoContext.getProtocolosAcerto();
      aplicacaoContext.getOrigensAcerto();
      aplicacaoContext.getEstadosAcerto();
      aplicacaoContext.getEstadosAuxilio();
      aplicacaoContext.getProtocolosAcertoCopart();
      aplicacaoContext.getTiposAcertoCopart();
      aplicacaoContext.getEstadosAcertoCopart();
      aplicacaoContext.getProtocolosAcertosDiversos();
      aplicacaoContext.getEventosDividas();
      aplicacaoContext.getServidoresDesligados();
      aplicacaoContext.getTiposDividas();
      aplicacaoContext.getItemTabelaTabelas();
      aplicacaoContext.getItemTabelaTipos();
      aplicacaoContext.getNomesServidoresSemVinculo();
    }
    if (getRoles().indexOf('prestador') < -1) {
      carregarIniciais();
    }
  }, []);

  const classes = useStyles();

  return (
    <Router history={history}>
      {!getToken()
        ? <div>
          Usuário não autenticado
        </div>
        : <div className={classes.root}>
          <ErrorBoundary history={history}>
            <MenuAppBar />
            <PageContent />
          </ErrorBoundary>
        </div>
      }
    </Router>
  );
}

export default App;
